export default "__VITE_ASSET__DKlKSc$Y__"